import { SubTechnology } from "./subtechnology";

export class Technology {
    idTechnology: string;
    name: string;
    idCategory: string;
    subTechnologies: SubTechnology[];
  }
